import React, { useCallback, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { useNavigate } from "react-router-dom";
import foodOffer from "../../assets/food/food-offer.svg";
import offerPVR from "../../assets/food/coupen.svg";
import offerINOX from "../../assets/food/offerInox.svg";
import foodOrderPVR from "../../assets/food/foodOrderpvr.svg";
import pen from "../../assets/food/penblack.svg";
import foodOrderINOX from "../../assets/food/foodOrderInox.svg";
import qrPVR from "../../assets/food/scanQRPVR.svg";
import qrINOX from "../../assets/food/scanQRInox.svg";
import backBtndesk from "../../assets/food/desktopBack.svg";
import settingtab from "../../assets/food/settingicon.svg";
import menuicon from "../../assets/food/menuimage.svg";
import foodbackground from "../../assets/food/Food_BG@3X.png";
// import foodvouchers from "../../assets/food/foodvouchers.svg";
import qrscan from "../../assets/food/qrscan.svg";
import { getResponsiveClasses } from "./component/ResponsiveClasses";
import { postDataService } from "src/services/postApiService";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import { Carousel } from "react-responsive-carousel";
import OrderSwiper from "./component/OrderSwiper";



const FBOption = ({ handleToggle }) => {
  const navigate = useNavigate();
  const [prepareMultiOrderStatus, setPrepareMultiOrderStatus] = useState([]);
  const isMobile = window.matchMedia("(max-width: 575px)").matches;
  const [images, setImages] = useState([]);

  localStorage.removeItem("cartItems");
  localStorage.removeItem("addFoodItems");
  localStorage.removeItem("userLocation");
  localStorage.removeItem("locationPermission");

  localStorage.removeItem("FoodListTimerId");
  localStorage.removeItem("timerId")
  // localStorage.removeItem("cartOffers");
  localStorage.setItem("upcomingMovieBack", true);
  localStorage.setItem("pageName", "FBOptionPage")

  const { currentClasses, getWindowWidth } = getResponsiveClasses();
  const theme = localStorage.getItem("theme");
  const splashData = JSON.parse(localStorage.getItem("splashData")) || [];

  const updateOrders = () => {
    const currentTime = new Date().getTime();
    const storedOrders = JSON.parse(localStorage.getItem("prepareMultiOrderStatus")) || [];

    // Filter out expired orders (older than 20 minutes)
    const filteredOrders = storedOrders.filter((order) => {
      const targetTime = new Date(order.targetTime).getTime();
      return targetTime > currentTime;
    });

    localStorage.setItem("prepareMultiOrderStatus", JSON.stringify(filteredOrders));
    setPrepareMultiOrderStatus(filteredOrders);
  };

  useEffect(() => {
    // updateOrders();
    fetchFoodImages();
    // const cleanupInterval = setInterval(updateOrders, 1000);
    // return () => clearInterval(cleanupInterval);
  }, []);


  const fetchFoodImages = () => {
    postDataService("v1/booking/food/images", {})
      .then((res) => {
        if (res?.result === "success" && res.output?.length > 0) {
          setImages(res.output);
        }
      })
      .catch((err) => {
        console.error("Error fetching images:", err);
      });
  };



  let dataLayer = window["dataLayer"] || [];
  return (
    <>
      <div className={currentClasses.fnbdeskdiv}
        style={
          isMobile
            ? {
              position: "relative",
              overflowY: "hidden",
              backgroundSize: "cover",
              overflow: "hidden",
              height: isMobile ? "calc(100vh - 172px)" : "",
              backgroundImage: `url(${foodbackground})`,
              backgroundRepeat: "inherit",
              backgroundPosition: "0 50%", // vertically center
              animation: "scrollBg 40s linear infinite"
            }
            : {}
        }
      >
        {/* {isMobile && (
          <div

          >
            {images.length > 0 && (
              <Carousel
                showArrows={false}
                autoPlay={true}
                infiniteLoop={true}
                interval={3000}
                showThumbs={false}
                stopOnHover={true}
                dynamicHeight={false}
                autoFocus={true}
                showStatus={false}
                showIndicators={false}
                swipeable={false}
              >
                {images.map((img, i) => (
                  <div key={i}>
                    <img
                      src={img.imageUrl}
                      alt={`Slide ${i}`}
                      style={{ width: "100%", height: "100%", objectFit: "cover" }}
                    />
                  </div>
                ))}
              </Carousel>
            )}
            <div
            // style={{
            //   position: "absolute",
            //   top: 0,
            //   left: 0,
            //   width: "100%",
            //   height: "100%",
            //   backgroundColor: "rgba(0,0,0,0.1)",
            //   pointerEvents: "none",
            // }}
            />
          </div>
        )}

        <div className="animation-wrapper">
      <img
        src={foodbackground}
        alt="Moving Food"
        className="slide-image"
      />
    </div> */}

        <style jsx>{`
    @keyframes scrollBg {
      0% {
        background-position: 50% 50%;
      }
      100% {
        background-position: 200% 50%;
      }
    }
  `}</style>


        <div className={currentClasses.fnbdeskdivInn} style={{ position: "relative", zIndex: 1 }}>
          {getWindowWidth && (
            <div>
              <img
                style={{
                  marginTop: "3px",
                  position: "absolute",
                  left: "15px",
                  top: "10px",
                  cursor: "pointer",
                }}
                src={backBtndesk}
                alt="backBtn"
                onClick={() => {
                  if (isMobile) {
                    handleToggle("MOVIES");
                  } else {
                    handleToggle("MOVIES");
                    navigate("/");
                  }
                }}

              />
              <h3 className="fnbTitle">Food & Beverages</h3>
            </div>
          )}
          {theme && isMobile ? (
            ''
          ) : (
            <div className="outer-fbOption">
              <div
                className={`fb-op-card ${getWindowWidth ? "secDisabled" : ""}`}
                onClick={() => {
                  navigate("/scan-qr");
                  dataLayer.push({
                    event: "food_scan_qr_code",
                  });
                }}
              >
                <div className="fb-op-cardInn">
                  <div className="fb-o-imgdiv">
                    <img
                      className="fb-o-img"
                      src={theme === "pvrTheme" ? qrPVR : qrINOX}
                      width={70}
                      height={70}
                      alt="Scan QR Code"
                    />
                  </div>
                  <div className="fb-ptitle">
                    <p className="fb-o-qr-p">Scan QR Code</p>
                    {getWindowWidth && (
                      <p className="fb-prg">Available on PVR INOX Mobile App</p>
                    )}
                  </div>
                </div>
              </div>
              {splashData?.home_food_offers_tabs === "true" &&
                <div
                  className={`fb-op-card ${getWindowWidth ? "secDisabled" : ""}`}
                  onClick={() => {
                    navigate("/select-cinema-for-fnb");
                    localStorage.setItem("FoodSelectType", "food_offers");
                    dataLayer.push({ 'event': 'food_offers' });
                  }}
                >
                  <div className="fb-op-cardInn">
                    <div className="fb-o-imgdiv">
                      <img
                        className="fb-o-img"
                        src={theme === "pvrTheme" ? foodOffer : offerINOX}
                        width={70}
                        height={70}
                        alt="Food Offers"
                      />
                    </div>
                    <div className="fb-ptitle">
                      <p className="fb-o-qr-p">Food Offers!</p>
                      {getWindowWidth && (
                        <p className="fb-prg">Available on PVR INOX Mobile App</p>
                      )}
                    </div>
                  </div>
                </div>
              }
              <div
                className="fb-op-card"
                onClick={() => {
                  navigate("/select-cinema-for-fnb");
                  localStorage.setItem('invoiceArray', '');
                  dataLayer.push({
                    event: "food_order",
                  });
                }}
              >
                <div className="fb-op-cardInn">
                  <div className="fb-o-imgdiv">
                    <img
                      className="fb-o-img"
                      src={theme === "pvrTheme" ? foodOrderPVR : foodOrderINOX}
                      width={70}
                      height={70}
                      alt="Order Food"
                    />
                  </div>
                  <div className="fb-ptitle">
                    <p className="fb-o-qr-p">Order Food</p>
                  </div>
                </div>
              </div>
            </div>
          )}
          <OrderSwiper orderFnb={true} pageName={"FBOptionPage"} />
          {/* {onSeatType === "true" && prepareMultiOrderStatus?.length > 0 && (
            <div className="vchrLanding">
              <div className="pyo-maindiv"
              >
                <Swiper
                  spaceBetween={
                    prepareMultiOrderStatus.filter(
                      (item) => item.deliveryMode === "ONSEAT" && item.currentStatus).length > 0
                      ? 5
                      : 0
                  }
                  slidesPerView={
                    prepareMultiOrderStatus.filter(
                      (item) => item.deliveryMode === "ONSEAT" && item.currentStatus).length > 1
                      ? getWindowWidth
                        ? 1
                        : 1.1
                      : 1.1
                  }
                  centeredSlides={true}
                  loop={false}
                  navigation
                  modules={[Navigation]}
                >
                  {prepareMultiOrderStatus.filter((item) => item?.offerActivated && item?.activateVoucher.length > 0).map((item, index) => {

                    const isRed = redTimers[item.en_bid]?.isRed;
                    return (
                      <SwiperSlide key={index}>
                        <CountdownTimer className={`orderstatusTimer ${isRed ? "red-timer" : ""}`} timerId={item.en_bid} duration={calculateDuration(item)} title="Offers expires in" />
                      </SwiperSlide>
                    )
                  })}

                  {prepareMultiOrderStatus.filter((item) => item.deliveryMode === "ONSEAT" && item.currentStatus && item?.currentStatus !== "Delivered" && !item?.offerActivated).map((item, index) => (
                    <SwiperSlide key={index}>
                      <div className="pyo-inndiv">
                        <img src={pen} alt="pen" />
                        <div className="fdDisc">
                          <p className="pyo-ptag">
                            {item?.currentStatus}
                          </p>
                          <p className="fbitms">{item?.foodItems?.[0]?.name}</p>
                        </div>
                        <button
                          onClick={() =>
                            navigate(`/order-status?bookingid=${item.en_bid}`)
                          }
                          className="pyo-btn"
                        >
                          View Status
                        </button>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          )} */}
        </div>
      </div>
      {theme && isMobile && (
        <div className="outer-fbOption fnb-mobile">
          {splashData?.home_food_offers_tabs === "true" &&
            <div className="fb-op-card" onClick={() => {
              navigate("/select-cinema-for-fnb");
              localStorage.setItem("FoodSelectType", "food_offers");
              dataLayer.push({ 'event': 'food_offers' });
            }}>
              <div className="fb-op-cardInns">
                <div className={theme === "pvrTheme" ? "fnb-yellow-button" : "fnb-other-button"}>
                  <img src={foodOffer} width={20} height={20} alt="Explore Menu" />
                  <span>Food Offers!</span>
                </div>
              </div>
            </div>
          }
          <div className="fb-op-card" onClick={() => {
            navigate("/select-cinema-for-fnb");
            localStorage.setItem("FoodSelectType", "food_order");
            dataLayer.push({ 'event': 'food_order' });
          }}>
            <div className="fb-op-cardInns">
              <div className={theme === "pvrTheme" ? "fnb-yellow-button" : "fnb-other-button"}>
                <img src={menuicon} width={20} height={20} alt="Explore Menu" />
                <span>Explore Menu</span>
              </div>
            </div>
          </div>

          <div className="fb-op-card"
            onClick={() => {
              navigate("/scan-qr");
              dataLayer.push({
                'event': 'food_scan_qr_code',
              });
            }}
          >
            <div className="fb-op-cardInns">
              <div className={theme === "pvrTheme" ? "fnb-yellow-button" : "fnb-other-button"}>
                <img src={qrscan} width={20} height={20} alt="Scan QR" />
                <span>Scan QR Code</span>
              </div>
            </div>
          </div>
        </div>
      )}

    </>
  );
};

export default FBOption;
